import { ExternalLink, Search } from 'lucide-react';
import { ContactSupportButton } from './ContactSupportButton';
import { Button } from './ui/button';

interface NoQuotesAvailableProps {
  advisorId?: string;
}

export function NoQuotesAvailable({ advisorId }: NoQuotesAvailableProps) {
  const handleCarrierSettings = () => {
    if (!advisorId) return;
    const url = `/advisors/${advisorId}/settings?tab=carrier-bga`;
    window.open(url, '_blank');
  };

  return (
    <div
      className="my-auto flex flex-col items-center justify-center gap-4 py-12"
      data-testid="shop-insurance-no-quotes-message"
    >
      <div className="bg-primary-50 mb-4 flex h-16 w-16 items-center justify-center rounded-full">
        <Search className="text-primary h-8 w-8" />
      </div>

      <h3 className="text-primary-dark mb-2 text-lg font-medium">No matching quotes found</h3>

      <p className="mb-6 max-w-md text-sm text-gray-700">
        We searched but couldn't find any quotes matching your current criteria.
      </p>

      <div className="flex flex-col gap-3 sm:flex-row">
        <Button
          variant="secondary"
          onClick={handleCarrierSettings}
          disabled={!advisorId}
        >
          <ExternalLink className="mr-2 h-4 w-4" />
          Review Carrier Settings
        </Button>

        <ContactSupportButton
          subject="Missing quotes - Need assistance"
          className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        />
      </div>

      <div className="mt-8 max-w-md rounded-lg bg-amber-50 p-4">
        <p className="text-xs text-amber-800">
          <strong>Note:</strong> Quote availability depends on client demographics, selected
          carriers, and product configurations.
        </p>
      </div>
    </div>
  );
}
